exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".src-client-survey-client-portal-client-portal-survey-slat-styles__surveyName {\n\tfont-weight: 300;\n\tmargin-left: 8px;\n}\n", ""]);

// exports
exports.locals = {
	"surveyName": "src-client-survey-client-portal-client-portal-survey-slat-styles__surveyName"
};